(() => {
  const root = document.querySelector("[data-b2g2]");
  if (!root) return;

  const dataEl = root.querySelector("[data-b2g2-products]");
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent || "{}");
  } catch (e) {
    console.error("[B2G2] Failed to parse products JSON", e);
    return;
  }

  const paidGrid = root.querySelector('[data-grid="paid"]');
  const freeGrid = root.querySelector('[data-grid="free"]');

  const addAllBtn = root.querySelector("[data-add-all]");
  const slotEls = [...root.querySelectorAll("[data-slot]")];

  const progressFill = root.querySelector(".b2g2__progressFill");

  const stepTabs = [...root.querySelectorAll("[data-step-tab]")];
  const panels = [...root.querySelectorAll("[data-step]")];

  const subtotalEl = root.querySelector("[data-subtotal-text]");

  // Step helper text (optional markup)
  const stepTextWrap = root.querySelector(".b2g2__stepCenterText");
  const stepTexts = stepTextWrap ? [...stepTextWrap.querySelectorAll("[data-step-text]")] : [];

  // Modal elements
  const modal = root.querySelector("[data-b2g2-modal]");
  const modalImg = root.querySelector("[data-b2g2-modal-image]"); // optional fallback img
  const modalPrice = root.querySelector("[data-b2g2-modal-price]");
  const modalTitle = root.querySelector("[data-b2g2-modal-title]");
  const modalOptions = root.querySelector("[data-b2g2-modal-options]");
  const modalAddBtn = root.querySelector("[data-b2g2-modal-add]");
  const modalCloseEls = [...root.querySelectorAll("[data-b2g2-close]")];

  // Slider elements (optional)
  const slider = root.querySelector("[data-b2g2-slider]");
  const slidesEl = root.querySelector("[data-b2g2-slides]");
  const dotsEl = root.querySelector("[data-b2g2-dots]");

  const state = {
    step: 1,
    paid: [], // {id, handle, title, image, price, compare_at_price, variant_id}
    free: [],
    modal: { type: null, base: null, product: null, chosenVariant: null }
  };

  const productCache = new Map();
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  const escapeHtml = (str) =>
    String(str ?? "").replace(/[&<>"']/g, (s) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;"
    }[s]));

  const formatPrice = (n) => {
    const num = Number(n) || 0;
    try { return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(num); }
    catch { return `₹${num}`; }
  };

  const formatMoneyNoDecimals = (n) => {
    const num = Number(n) || 0;
    try {
      return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(num);
    } catch {
      return `₹${Math.round(num)}`;
    }
  };

  function centsToMoney(cents) { return (Number(cents) || 0) / 100; }

  // ---------- Step center text ----------
  function updateStepCenterText(step) {
    if (!stepTexts.length) return;

    stepTexts.forEach((el) => {
      const s = Number(el.getAttribute("data-step-text"));
      const isActive = s === Number(step);
      el.style.display = isActive ? "block" : "none";
      el.style.opacity = isActive ? "1" : "0";
    });
  }

  // ---------- Progress ----------
  function syncProgress() {
    if (!progressFill) return;
    const totalPicked = state.paid.length + state.free.length;
    const pct = Math.min(100, (totalPicked / 4) * 100);
    progressFill.style.width = pct + "%";
  }

  // ---------- Savings ----------
  function computeSavings() {
    return state.paid.reduce((sum, p) => {
      const price = Number(p.price) || 0;
      const compare = Number(p.compare_at_price) || 0;
      return sum + Math.max(0, compare - price);
    }, 0);
  }

  function ensureSavingsEl() {
    const trayMeta = root.querySelector(".b2g2__trayMeta");
    if (!trayMeta || !addAllBtn) return null;

    let el = trayMeta.querySelector("[data-b2g2-savings]");
    if (!el) {
      el = document.createElement("div");
      el.setAttribute("data-b2g2-savings", "");
      el.style.cssText = `
        margin: 10px 0 10px;
        font-size: 14px;
        font-weight: 700;
        opacity: .9;
        text-align: center;
        color: #0a7a0a;
      `;
      trayMeta.insertBefore(el, addAllBtn);
    }
    return el;
  }

  // ---------- Variant helpers ----------
  function pickFirstAvailableVariantIdFromEmbedded(p) {
    const v = (p.variants || []).find(x => x.available);
    return v ? v.id : null;
  }

  function arrFor(type) { return type === "paid" ? state.paid : state.free; }

  function isSelected(type, productId) {
    return arrFor(type).some(p => String(p.id) === String(productId));
  }

  function addSelection(type, item) {
    const arr = arrFor(type);
    if (isSelected(type, item.id)) return;
    if (arr.length >= 2) return;

    arr.push(item);
    if (type === "paid" && state.paid.length === 2) setStep(2);
  }

  function removeSelection(type, productId) {
    if (type === "paid") {
      state.paid = state.paid.filter(p => String(p.id) !== String(productId));
      if (state.paid.length < 2) {
        state.free = [];
        setStep(1);
      }
    } else {
      state.free = state.free.filter(p => String(p.id) !== String(productId));
    }
  }

  function remainingToPick() {
    return (2 - state.paid.length) + (2 - state.free.length);
  }

  function getPaidSubtotal() {
    return state.paid.reduce((sum, p) => sum + (Number(p.price) || 0), 0);
  }

  function setBarText(txt) {
    if (addAllBtn) addAllBtn.textContent = txt;
    if (subtotalEl) subtotalEl.textContent = txt;
  }

  // ---------- Cards rendering ----------
  function renderCardPrice(p, type) {
    const price = Number(p.price) || 0;
    const compare = Number(p.compare_at_price) || 0;

    if (type === "paid") {
      if (compare > price) return `${formatPrice(price)} <s>${formatPrice(compare)}</s>`;
      return `${formatPrice(price)}`;
    }

    const regular = compare > 0 ? compare : price;
    return `<span class="b2g2__freeTag">FREE</span> <s>${formatPrice(regular)}</s>`;
  }

  const cardHTML = (p, type) => {
    const variantId = pickFirstAvailableVariantIdFromEmbedded(p);
    const disabled = !p.available || !variantId;

    return `
      <button class="b2g2__card ${disabled ? "is-disabled" : ""}"
        type="button"
        data-type="${type}"
        data-product-id="${p.id}"
        ${disabled ? "disabled" : ""}
      >
        <div class="b2g2__img">
          ${p.image ? `<img loading="lazy" src="${p.image}" alt="${escapeHtml(p.title)}">` : ""}
        </div>
        <div class="b2g2__meta">
          <div class="b2g2__name">${escapeHtml(p.title)}</div>
          <div class="b2g2__price">${renderCardPrice(p, type)}</div>
        </div>
        <div class="b2g2__check" aria-hidden="true"></div>
      </button>
    `;
  };

  function render() {
    if (paidGrid) paidGrid.innerHTML = (data.paid || []).map((p) => cardHTML(p, "paid")).join("");
    if (freeGrid) freeGrid.innerHTML = (data.free || []).map((p) => cardHTML(p, "free")).join("");
    syncUI();
    updateStepCenterText(state.step);
  }

  // ---------- Slots ----------
  function syncSlots() {
    slotEls.forEach((slot) => {
      slot.classList.remove("is-filled");
      slot.innerHTML = `<span class="b2g2__slotPlus">+</span>`;
      slot.removeAttribute("data-filled-type");
      slot.removeAttribute("data-filled-product-id");
    });

    state.paid.forEach((p, idx) => {
      const slot = slotEls[idx];
      if (!slot) return;
      slot.classList.add("is-filled");
      slot.setAttribute("data-filled-type", "paid");
      slot.setAttribute("data-filled-product-id", String(p.id));
      slot.innerHTML = `
        ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}">` : ""}
        <span class="b2g2__slotRemove">×</span>
      `;
    });

    state.free.forEach((p, idx) => {
      const slot = slotEls[idx + 2];
      if (!slot) return;
      slot.classList.add("is-filled");
      slot.setAttribute("data-filled-type", "free");
      slot.setAttribute("data-filled-product-id", String(p.id));
      slot.innerHTML = `
        ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}">` : ""}
        <span class="b2g2__slotRemove">×</span>
      `;
    });
  }

  // ---------- Celebration ----------
  let didCelebrate = false;

  function resetCelebrateIfNotComplete() {
    if ((state.paid.length + state.free.length) < 4) didCelebrate = false;
  }

  function triggerCelebrate() {
    if (didCelebrate) return;
    didCelebrate = true;

    if (!document.getElementById("b2g2RubanCSS")) {
      const style = document.createElement("style");
      style.id = "b2g2RubanCSS";
      style.textContent = `
        .b2g2Ruban { position: fixed; inset: 0; pointer-events: none; z-index: 999999; overflow: hidden; }
        .b2g2Ruban__r { position: absolute; bottom: -60px; opacity: .98; transform-origin: center; will-change: transform, opacity;
          animation: b2g2RubanPop var(--dur) cubic-bezier(.18,.82,.22,1) forwards; }
        .b2g2Ruban__r::before{ content:""; position:absolute; inset:0; border-radius: 999px; background: var(--bg);
          box-shadow: inset 0 0 0 1px rgba(255,255,255,.25); }
        .b2g2Ruban__r::after{ content:""; position:absolute; inset:-18% -60%; border-radius: 999px;
          background: radial-gradient(circle at 30% 20%, rgba(255,255,255,.35), transparent 55%),
                      radial-gradient(circle at 70% 80%, rgba(0,0,0,.12), transparent 60%);
          transform: rotate(18deg); opacity: .7; }
        @keyframes b2g2RubanPop {
          0% { transform: translate3d(0,0,0) rotate(var(--rot0)); opacity: 0; }
          12% { opacity: 1; }
          55% { transform: translate3d(var(--dx1), calc(-1 * var(--rise)), 0) rotate(var(--rot1)); opacity: 1; }
          100% { transform: translate3d(var(--dx2), calc(-1 * var(--rise) + 55vh), 0) rotate(var(--rot2)); opacity: 0; }
        }
      `;
      document.head.appendChild(style);
    }

    const overlay = document.createElement("div");
    overlay.className = "b2g2Ruban";
    overlay.setAttribute("aria-hidden", "true");
    document.body.appendChild(overlay);

    const anchor = addAllBtn || root;
    const rect = anchor.getBoundingClientRect();
    const originX = rect.left + rect.width / 2;

    const rand = (min, max) => Math.random() * (max - min) + min;

    const count = 32;
    const spread = 170;

    for (let i = 0; i < count; i++) {
      const r = document.createElement("i");
      r.className = "b2g2Ruban__r";

      const w = rand(2, 4);
      const h = rand(22, 42);
      r.style.width = `${w}px`;
      r.style.height = `${h}px`;

      const hue = Math.floor(rand(0, 360));
      r.style.setProperty("--bg", `linear-gradient(180deg,
        hsl(${hue} 92% 62%),
        hsl(${(hue + 16) % 360} 92% 54%)
      )`);

      const startX = originX + rand(-spread, spread);
      r.style.left = `${startX}px`;

      r.style.setProperty("--rise", `${rand(240, 380)}px`);
      r.style.setProperty("--dx1", `${rand(-90, 90)}px`);
      r.style.setProperty("--dx2", `${rand(-160, 160)}px`);

      r.style.setProperty("--rot0", `${Math.floor(rand(-40, 40))}deg`);
      r.style.setProperty("--rot1", `${Math.floor(rand(-220, 220))}deg`);
      r.style.setProperty("--rot2", `${Math.floor(rand(-320, 320))}deg`);

      r.style.setProperty("--dur", `${rand(1.15, 1.55)}s`);
      r.style.animationDelay = `${rand(0, 160)}ms`;

      overlay.appendChild(r);
    }

    window.setTimeout(() => overlay.remove(), 1900);
  }

  // ---------- Sync UI ----------
  function syncUI() {
    root.querySelectorAll(".b2g2__card").forEach((el) => {
      const type = el.dataset.type;
      const pid = el.dataset.productId;
      el.classList.toggle("is-selected", isSelected(type, pid));
    });

    // step 2 enabled only after 2 paid
    const canGoStep2 = state.paid.length === 2;
    if (stepTabs[1]) stepTabs[1].disabled = !canGoStep2;

    resetCelebrateIfNotComplete();

    const paidRemaining = 2 - state.paid.length;
    const freeRemaining = 2 - state.free.length;

    if (state.paid.length < 2) {
      setBarText(`Select ${paidRemaining} Item${paidRemaining > 1 ? "s" : ""}`);
      if (addAllBtn) addAllBtn.disabled = true;
      syncSlots();
      syncProgress();
      updateStepCenterText(1);
      return;
    }

    if (state.free.length < 2) {
      setBarText(`Select ${freeRemaining} Free Item${freeRemaining > 1 ? "s" : ""}`);
      if (addAllBtn) addAllBtn.disabled = true;
      syncSlots();
      syncProgress();
      updateStepCenterText(2);
      return;
    }

    // All selected
    const subtotal = getPaidSubtotal();
    setBarText(`Subtotal ${formatMoneyNoDecimals(subtotal)} • Shop Now`);
    if (addAllBtn) addAllBtn.disabled = false;

    const savingsEl = ensureSavingsEl();
    const savings = computeSavings();
    if (savingsEl) {
      if (savings > 0) {
        savingsEl.textContent = `Total Savings ${formatMoneyNoDecimals(savings)}`;
        savingsEl.style.display = "";
      } else {
        savingsEl.style.display = "none";
      }
    }

    syncSlots();
    syncProgress();
    updateStepCenterText(state.step);

    if ((state.paid.length + state.free.length) === 4) triggerCelebrate();
  }

  // ---------- Tabs / Step ----------
  function setStep(step) {
    state.step = step;

    panels.forEach(p => p.classList.toggle("is-active", Number(p.dataset.step) === step));
    stepTabs.forEach(t => t.classList.toggle("is-active", Number(t.dataset.stepTab) === step));

    updateStepCenterText(step);
    syncProgress();
  }

  // ---------- Product JSON from embedded lists ----------
  function findEmbedded(type, productId) {
    const list = type === "paid" ? (data.paid || []) : (data.free || []);
    return list.find(p => String(p.id) === String(productId));
  }

  // ---------- Modal / Quick view ----------
  const modalReady = () => !!(modal && modalPrice && modalTitle && modalOptions && modalAddBtn);

  function openModal() {
    if (!modalReady()) return;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";

    state.modal = { type: null, base: null, product: null, chosenVariant: null };

    if (modalOptions) modalOptions.innerHTML = "";
    if (slidesEl) slidesEl.innerHTML = "";
    if (dotsEl) dotsEl.innerHTML = "";
    if (modalImg) modalImg.style.display = "";
  }

  modalCloseEls.forEach(el => el.addEventListener("click", closeModal));

  async function loadProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error("Failed to load product JSON");
    const prod = await res.json();
    productCache.set(handle, prod);
    return prod;
  }

  function renderModalPrice(type, variant) {
    const price = centsToMoney(variant.price);
    const compare = centsToMoney(variant.compare_at_price);

    if (type === "paid") {
      if (compare > price) return `${formatPrice(price)} <s>${formatPrice(compare)}</s>`;
      return `${formatPrice(price)}`;
    }
    const regular = compare > 0 ? compare : price;
    return `<span class="b2g2__freeTag">FREE</span> <s>${formatPrice(regular)}</s>`;
  }

  // ---------- Slider ----------
  function buildSlider(images, title) {
    if (!slider || !slidesEl || !dotsEl) return false;

    const imgs = Array.isArray(images) ? images.filter(Boolean) : [];
    slidesEl.innerHTML = "";
    dotsEl.innerHTML = "";

    if (!imgs.length) return false;

    imgs.forEach((src, idx) => {
      const slide = document.createElement("div");
      slide.className = "b2g2Modal__slide";
      slide.innerHTML = `<img src="${src}" alt="${escapeHtml(title)}" loading="lazy">`;
      slidesEl.appendChild(slide);

      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "b2g2Modal__dot" + (idx === 0 ? " is-active" : "");
      dot.addEventListener("click", () => {
        slidesEl.scrollTo({ left: slidesEl.clientWidth * idx, behavior: "smooth" });
      });
      dotsEl.appendChild(dot);
    });

    const onScroll = () => {
      const i = Math.round(slidesEl.scrollLeft / Math.max(1, slidesEl.clientWidth));
      [...dotsEl.children].forEach((d, di) => d.classList.toggle("is-active", di === i));
    };

    slidesEl.addEventListener("scroll", onScroll, { passive: true });
    slidesEl.scrollLeft = 0;
    onScroll();

    return true;
  }

  async function openQuickView(type, productId) {
    if (!modalReady()) return false;
    if (type === "free" && state.paid.length !== 2) return true;

    const base = findEmbedded(type, productId);
    if (!base) return false;

    const prod = await loadProduct(base.handle);
    const defaultVar = prod.variants.find(v => v.available) || prod.variants[0];
    if (!defaultVar) return false;

    state.modal.type = type;
    state.modal.base = base;
    state.modal.product = prod;
    state.modal.chosenVariant = defaultVar;

    if (modalTitle) modalTitle.textContent = prod.title;
    if (modalPrice) modalPrice.innerHTML = renderModalPrice(type, defaultVar);

    const allImages =
      (prod.images && prod.images.length) ? prod.images :
      (base.image ? [base.image] : []);

    if (modalImg) {
      modalImg.src = allImages[0] || "";
      modalImg.alt = prod.title;
      modalImg.style.display = "block";
    }

    const sliderOk = buildSlider(allImages, prod.title);
    if (sliderOk && modalImg) modalImg.style.display = "none";

    // Options UI kept as-is in your file (you already have it above)
    // buildOptionsUI(prod, defaultVar);

    if (modalAddBtn) {
      modalAddBtn.disabled = false;
      modalAddBtn.textContent = "Add to Box";
    }

    openModal();
    return true;
  }

  if (modalAddBtn) {
    modalAddBtn.addEventListener("click", () => {
      const type = state.modal.type;
      const base = state.modal.base;
      const prod = state.modal.product;
      const v = state.modal.chosenVariant;
      if (!type || !base || !prod || !v) return;

      const item = {
        id: base.id,
        handle: base.handle,
        title: base.title,
        image: base.image,
        price: centsToMoney(v.price),
        compare_at_price: centsToMoney(v.compare_at_price),
        variant_id: v.id
      };

      if (!isSelected(type, item.id)) addSelection(type, item);
      closeModal();
      syncUI();
    });
  }

  // ---------- Cart add ----------
  async function addAllToCart() {
    if (remainingToPick() !== 0) return;
    if (addAllBtn) addAllBtn.disabled = true;

    const items = [];
    const pushItem = (p, group) => {
      const embedded = findEmbedded(group, p.id);
      const vid = p.variant_id || (embedded ? pickFirstAvailableVariantIdFromEmbedded(embedded) : null);
      if (!vid) return;
      items.push({ id: vid, quantity: 1, properties: { _b2g2_group: group } });
    };

    state.paid.forEach(p => pushItem(p, "paid"));
    state.free.forEach(p => pushItem(p, "free"));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error("Add to cart failed");

      // ✅ Refresh cart (so drawer shows latest items)
      if (window.Shopify && typeof Shopify.getCart === "function") {
        Shopify.getCart();
      } else {
        await fetch("/cart.js", { headers: { Accept: "application/json" } });
      }

      // ✅ Open cart drawer
      if (window.jQuery) {
        jQuery(".minicart-inner").addClass("show").removeClass("dontshow");
      } else {
        const drawer = document.querySelector(".minicart-inner");
        if (drawer) drawer.classList.add("show");
      }

    } catch (e) {
      console.error(e);
      alert("Couldn’t add items to cart. Please try again.");
      if (addAllBtn) addAllBtn.disabled = false;
      syncUI();
    }
  }

  // ---------- Click handlers ----------
  root.addEventListener("click", async (e) => {
    // Slot remove
    const slot = e.target.closest("[data-slot]");
    if (slot && slot.classList.contains("is-filled")) {
      const type = slot.getAttribute("data-filled-type");
      const pid = slot.getAttribute("data-filled-product-id");
      if (type && pid) {
        removeSelection(type, pid);
        syncUI();
      }
      return;
    }

    // Card click
    const card = e.target.closest(".b2g2__card");
    if (card) {
      const type = card.dataset.type;
      const pid = card.dataset.productId;

      // PLUS click = direct add/remove
      const isPlusClick = !!e.target.closest(".b2g2__check");
      if (isPlusClick) {
        e.preventDefault();
        e.stopPropagation();

        if (isSelected(type, pid)) {
          removeSelection(type, pid);
          syncUI();
          return;
        }

        if (type === "free" && state.paid.length !== 2) return;

        const base = findEmbedded(type, pid);
        if (!base) return;
        const variantId = pickFirstAvailableVariantIdFromEmbedded(base);
        if (!variantId) return;

        addSelection(type, {
          id: base.id,
          handle: base.handle,
          title: base.title,
          image: base.image,
          price: Number(base.price) || 0,
          compare_at_price: Number(base.compare_at_price) || 0,
          variant_id: variantId
        });

        syncUI();
        return;
      }

      // Image/title click -> mobile quick view
      const clickedImageOrTitle = !!e.target.closest(".b2g2__img, .b2g2__name");

      if (isSelected(type, pid)) {
        removeSelection(type, pid);
        syncUI();
        return;
      }

      if (type === "free" && state.paid.length !== 2) return;

      if (isMobile() && clickedImageOrTitle) {
        try {
          const opened = await openQuickView(type, pid);
          if (opened) return;
        } catch (err) {
          console.error(err);
        }
      }

      const base = findEmbedded(type, pid);
      if (!base) return;
      const variantId = pickFirstAvailableVariantIdFromEmbedded(base);
      if (!variantId) return;

      addSelection(type, {
        id: base.id,
        handle: base.handle,
        title: base.title,
        image: base.image,
        price: Number(base.price) || 0,
        compare_at_price: Number(base.compare_at_price) || 0,
        variant_id: variantId
      });

      syncUI();
      return;
    }

    // Tabs
    const tab = e.target.closest("[data-step-tab]");
    if (tab) {
      const step = Number(tab.dataset.stepTab);
      if (step === 2 && state.paid.length !== 2) return;
      setStep(step);
      return;
    }

    // Add button
    const addBtn = e.target.closest("[data-add-all]");
    if (addBtn) addAllToCart();
  });

  // ---------- Init ----------
  render();
  syncProgress();
})();
